import React from "react";

const Search = ({ searchQuery, setSearchQuery }) => {
  return (
    <div>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search Projects"
        className="px-4 py-2 border border-gray-300 rounded-md"
      />
    </div>
  );
};

export default Search;
